/* TK-POPUP (08/10/2026) — popup Totkind, clone lb-popup.js cua litborne.co, ban "thuong": KHONG co buoc SDT/OTP.
   3 step: Quiz (mua cho ai) -> Email -> Reward (HIEN ma WELCOME5 = 5% + nut tu ap /discount/).
   Klaviyo account Totkind U6uy9R, list UaSytN. Su kien popup + lead -> kho Totkind (api.totkind.com/px).
   Trigger (OR): 30s on page | scroll 50% | exit-intent (desktop) | quick scroll-up (mobile).
   Targeting: new visitor (chua signup, khong o /account|/checkout|/cart, khong tu utm email/sms).
   Dismiss (X hoac "No thanks") -> an popup 7 ngay, KHONG con floating pill (bo 08/10); signup -> tat vinh vien. Debug: ?lbpopup=1 ep mo, =0 tat. */
(function () {
  'use strict';

  /* Ma khach dung chung voi script theo doi (lb-px.js) va Web Pixel checkout. 26/09: Shopify bo cookie
     _shopify_y tu 25/09 07:00 LA -> truoc day doc cookie khong ra la BO QUA, popup van hien nhung kho
     khong ghi duoc lan hien / buoc / lead nao. Thu tu: cookie cu -> uniqToken cua Shopify -> ma tu sinh. */
  function maKhach(cookieCu) {
    if (cookieCu) return cookieCu;
    try {
      var t = window.ShopifyAnalytics && ShopifyAnalytics.lib && ShopifyAnalytics.lib.user && ShopifyAnalytics.lib.user().traits().uniqToken;
      if (t) return String(t);
    } catch (e) {}
    /* 27/09: ma chinh thuc do Web Pixel ghi (event.clientId) — dung khi uniqToken bien mat */
    try { return localStorage.getItem('_lbx_sy') || localStorage.getItem('_lbx_id') || ''; } catch (e) { return ''; }
  }
  if (window.__tkPopupBoot) return; window.__tkPopupBoot = 1;

  var KLAVIYO_COMPANY = 'U6uy9R';
  var KLAVIYO_LIST = 'UaSytN';
  var CODE = 'WELCOME5';
  var STATE_KEY = 'tk-popup-state';
  var DISMISS_DAYS = 7;

  function qs(k) { try { return new URLSearchParams(location.search).get(k); } catch (e) { return null; } }
  function st() { try { return JSON.parse(localStorage.getItem(STATE_KEY) || '{}'); } catch (e) { return {}; } }
  function setSt(patch) {
    try { var s = st(); for (var k in patch) s[k] = patch[k]; localStorage.setItem(STATE_KEY, JSON.stringify(s)); } catch (e) {}
  }
  function assetUrl(name) {
    var me = document.querySelector('script[src*="tk-popup"]');
    if (!me) return name;
    return me.src.replace(/tk-popup\.js[^?]*/, name).split('?')[0] + (me.src.match(/\?v=[^&]+/) ? me.src.match(/\?v=[^&]+/)[0] : '');
  }

  /* ---------- gate ---------- */
  var debug = qs('tkpopup');
  if (debug === '0') return;
  var s0 = st();
  if (debug !== '1') {
    if (s0.signedUp) return;
    if (/^\/(account|checkout|cart|thank_you|challenge)/.test(location.pathname)) return;
    var utm = (qs('utm_source') || '') + ' ' + (qs('utm_medium') || '');
    if (/klaviyo|email|sms|text/i.test(utm)) return; /* khach tu email/sms = da co contact */
  }
  var dismissedRecently = s0.dismissedAt && (Date.now() - s0.dismissedAt < DISMISS_DAYS * 864e5);

  /* ---------- styles ---------- */
  var GOLD = '#F3D7A6', INKBTN = '#892B49';   /* Totkind: nut man do-man chu trang, chu nhan kem vang am */
  /* Co quoc gia dang PNG w40 nhung thang vao file (~4.5KB ca 15 la).
     Khong dung emoji: Windows khong co font co -> ra o vuong.
     Khong goi CDN: mat mang la mat co. Khong dung SVG: rieng co ES nang 153KB. */
var CO = {"US":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAVBAMAAADGNLEtAAAALVBMVEX////GU3LZjKGzGUINM2PsxtAYPWotT3hed5enma46WoBPa46zGkMkR3Jrgp+6ntXWAAAAiklEQVQY02Nwc0lJcQMSxghgw+CRVdaWkVXWooQEGFxaPLxKWjxcGJCBn1fJExAWRAJglUuAKlEEPdyXgA1A0e62LTu9bFt2CopF3iCh9LItKE5yX5tVe31tVgmq9pL0NLcy95RQJMAAdiUQo2ifCQUoKrECY0xgw6CEBWDXLogFYBfECrBahM1JAItMTcEiMDpsAAAAAElFTkSuQmCC","CA":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAMAAADImI+JAAAASFBMVEX/////ubn/oqL/Z2f/Jib/09P/7e3/AAD/+/v/Gxv/W1v/rq7/eXn/nZ3/DAz/OTn/AwP/Pj7//Pz/QED/PT3/g4P/xsb/xcWY5npoAAAAkUlEQVQoz43TyQ7DIAxFUQbDNZCx4///aTdt00ohsXdPHIFsGce33E79nO5AvRjhGCxQVYs41fMbpUIVw9MzwHwKk4sA0aUj6IdW7iNAGEobfBfmBbgC3IAld6HKllhEuzDwV6HfjJ+2OPmjrlP5pJKOx5PfsuSTOWZZY61xlWxYiufDuD3eG2FrRpiSEe5+hRcblQ+AegtNbgAAAABJRU5ErkJggg==","GB":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAMAAADImI+JAAAANlBMVEX////w8vfyxcx8jbJCWpAOLHFVa5sBIWnIEC7WTGLnv8qAkLTheYpecqHx0digrMfz3+T21dqBS5WQAAAApUlEQVQoz8WTyxpFMAyEpyqOuhTv/7IntImmurAzC59kfsIIhA5wnn6iASMLgzbIT2Fk6joUaAUKBsiJm+kJ0iyuR1mQBam8Cex1dINkZ6EesSZwrR8JfdYWl7AcbCRw5ypytYmPpy6w3X6jL8HXL6PxOODgTPYEcnXmFe94cuBsdJzwpIFrRwK3WPkJLQqL2aUoUVisXjOvLizWWNyMVljrV0gz/wdhEi0lRIbcAAAAAElFTkSuQmCC","IE":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUBAMAAAANaGKIAAAAD1BMVEUWm2L/iD7///+y3sv/174BQJ8QAAAAGElEQVQY02NgAANmJTBwFAQDhlHBwSQIALIxHTlPIfkHAAAAAElFTkSuQmCC","AU":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAUCAMAAADImI+JAAAAdVBMVEUBIWn+/v8LKm8rRoLsS2lZa5sCI2rkACvAyNojP317jLGrtc2qtc3FzN1fc6FBWY/5w83ecIr+8vQRL3P5x9DY3ejU2OVeZpZLVIn709oYNndNZJacqcWLmrra3unVZ4Xy9Pj22uFEXJHIz94VM3XUZYPb3+rlcwqvAAAAz0lEQVQoz7WQyRKDIBBEB2STRHHfTdQs//+JQVxiSlNFDunLAPOomW4gycVnAHDi/KwLoyEJ4EjFgyQpXcBcY54C+IpmdAQNNmxavv8+C62sLyPEeVRGXTbelx72BF5BfqC16bpgB25lRnd6KucoKvuP0UaOdObT4CUkzEczNA3ItZheq2oxhKYUlMHmeNiK4ps3+7jXzFSN0W3g/jMgY5WSwS+i1BLcBrS4c6x+xrJpZGxDtgi1NpwSCAlls44rxG5vfEnxHozjvUFaw//0ApepC3HnUeodAAAAAElFTkSuQmCC","DE":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAYAgMAAAD16ldTAAAACVBMVEUAAADdAAD/zgDGIigcAAAAFUlEQVQY02NgoBEIhQPqMlfBAVWZANYST7G6bxb2AAAAAElFTkSuQmCC","FR":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAbBAMAAAD8PtBdAAAAD1BMVEUAJlT////OESbvr7aqtsYrjF9NAAAAGUlEQVQoz2NgAAMWQTAwUgIDhlHBUUG8ggBpKyX5efKDZQAAAABJRU5ErkJggg==","ES":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAbCAMAAAA5zj1cAAAApVBMVEX6vQCtFRnBPxP3tgCkSRTxsQC9miCtkjL3ugDcdwrVkwndpwauUEi3k3ecLQyvGx01YomtXy3Zhha+gw+4LiCzn4jKeBKyYgjmoAOkXUK/RhC1kJmmKh+0oKCbYwN5OAWWHxSVi0HypQNcdGsDAgC9g1j6vgSWhnLfsSXCn169cE24eBuaNwzQaiOYagW8bxWIOhqoKhPLdq4yUHR+UgVZLWaBHkAs3esWAAAAk0lEQVQ4y+WTVxLDIAxESQwBAwb33tKc3sv9j5YbWJp8JvurNzsrzYpMkCI/BU6RIt9phqIcJSOpEGBu7c2WA+iXOWmbtTmTACh42PdelSgwp+d2nXdvTjuAc3X5vL6qJo4XQEZ9qd8PXaR7yDE5GFOf6XbNRrmB8cgcKaUraJm5z4NiE4RLH3FyIUaG6Pb85XN9AIg9CvrV7UGSAAAAAElFTkSuQmCC","IT":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAbBAMAAAD8PtBdAAAAElBMVEXOKzcAkkb///+q28EBkkbvt7tlcfnnAAAAGUlEQVQoz2NwFAQBYSUwCGCAgFHBUUG8ggBTFC/I4rFoIQAAAABJRU5ErkJggg==","PT":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAbCAMAAAA5zj1cAAAA3lBMVEX/AAAAZgDjeAn6AAAEYwDcogDtUwqbtwDmXhr5QT76fHz+/v62xOLf5PJ6pgC/zgCpvAD1LwCYswCjuADuYyutwwD6MC/1ZwDXxADjjADuSgDsAADllgDkqgDo3wDkswDvIwDZ1wDSqQBclgDopwDpxADoaxJ+rADcjwreTADrNwCKqwA1fgBRhgDM0gAZbQDq6gDrOgD8EhLvRAr22M3qk1L6OTbsfip4lMmZrNg7hADjFADRggDyBADkmDXcvzH0dFOTrhryRjl9jiS2ozbcXEvrMwAAWgDz9fry9PltbfP7AAAA0ElEQVQ4y+XTxxKCQBAEUNgl56CIAZUgihkQzDn//w95t8rBs/b5naZ7CPItxKf8MKRGEf4CDstl0+s47SLYNaj7KKqvexUYDjTuhuMY9zkvhOBkOg0ZIcsEJtzYGICKMbZ4UZJE3toiBoAGq3ElUZbFEkdXEQDH7ATNF8vlYo7ajg1AljXz/CnLD4unG1UA+gp11WeSNNMPnaAGQMo1zygVhBTtm806dEdFHVxOScLvWi5d0Iw2JI+9fq1RKep6paoaHbT0b9bjM/j/fuYzfAEwIRPN3DfXmAAAAABJRU5ErkJggg==","AT":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAbAQMAAAA03l8tAAAABlBMVEXIEC7///94b0yLAAAAEklEQVQI12NgIAv8BwGSSbIAADA3LNT5TsD+AAAAAElFTkSuQmCC","BE":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAjBAMAAAAUF1WdAAAAD1BMVEXvM0AAAAD92iX4oi2okRgdxzYaAAAAGUlEQVQoz2MQBAMRJTAwYICAUcFRwWEhCADCrTMjCu9IjwAAAABJRU5ErkJggg==","SE":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAZAgMAAAA+toT2AAAACVBMVEUAUpP+ywB/j0kXq4KkAAAAGklEQVQY02NgYGCYmsAAA7RmhsIBSUy6OhIASfMjv9uXrDcAAAAASUVORK5CYII=","CH":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAoBAMAAAB+0KVeAAAAElBMVEX/AAD/////wMD/gID/YGD/8PBDRn5nAAAANklEQVQoz2NgGLzA2djYBENQUVBQaJALsigBQaCgoCiIdoAKMgsiAQN6C2J10lAJT9yJYfAAAHGvEL146aHXAAAAAElFTkSuQmCC","MT":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACgAAAAbBAMAAAD8PtBdAAAAIVBMVEX////PFCv5+fn04OPw29758vPl5eX77u/sztLd3d3g4OCFpgNSAAAARUlEQVQoz2NggANBOGBgYHUJwBRkVjLAEGS1mNYcgC7Iohaa5IAhqKWEKcjukdZSQJRFDOzGBZiCDApYHI/VR6OC1BQEABQgGV7i2R6rAAAAAElFTkSuQmCC"};
  var css = '' +
    '#tk-pop{position:fixed;inset:0;z-index:2147483000;display:flex;align-items:center;justify-content:center;font-family:var(--font-body--family,system-ui,sans-serif)}' +
    '#tk-pop[hidden]{display:none!important}' +
    /* Lop toi phang chong len anh: mau nen phai nam o LAYER CUOI khi dung nhieu lop background */
    '#tk-pop .lbp-bg{position:absolute;inset:0;background:linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)),url(' + JSON.stringify(assetUrl('tk-popup-bg.webp')) + ') 50%/cover no-repeat #000}' +
    /* Card KHONG duoc co nen rieng: card chi rong 560px giua man hinh rong, dat lop phu o day
       thi no thanh vet toi hinh bau duc lo lung, nhin ro mep — xau. Lop phu nam o .lbp-bg (phu kin
       toan man) de toi DEU, khong co mep nao de nhin thay. */
    '#tk-pop .lbp-card{position:relative;display:flex;flex-direction:column;align-items:center;text-align:center;gap:.65rem;width:100%;max-width:560px;padding:2rem 1.25rem;color:#fff}' +
    '#tk-pop .lbp-x{position:fixed;top:14px;left:14px;z-index:3;width:38px;height:38px;border:0;border-radius:50%;background:#1d2333;color:#fff;font-size:17px;line-height:38px;cursor:pointer}' +
    '#tk-pop .lbp-logo{width:150px;margin-bottom:.4rem}' +
    '#tk-pop .lbp-h2{font-family:var(--font-heading--family,Georgia,serif);font-size:clamp(30px,4.5vw,48px);line-height:1.1;letter-spacing:-1px;margin:0;color:#fff!important;text-shadow:0 2px 16px rgba(0,0,0,.75)}' +
    /* color PHAI !important: man reward dung the <h2> mang class nay, ma .co con rule
       h2{color:var(--lb-text)!important} tu dot lat nen trang -> muc den de len nen toi = mat hut.
       Tren .com khong co rule do nen vang van an — cung mot code, hai ket qua khac nhau.
       Day la lan thu BA dinh bay "theme dat color truc tiep len the", xem .lbp-h2 va o tick. */
    '#tk-pop .lbp-h1{font-family:var(--font-heading--family,Georgia,serif);font-size:clamp(34px,5.5vw,56px);line-height:1.1;letter-spacing:-1px;margin:0;color:' + GOLD + '!important;text-shadow:0 2px 16px rgba(0,0,0,.8)}' +
    '#tk-pop .lbp-sub{font-size:16px;margin:.35rem 0 .4rem;text-shadow:0 1px 8px rgba(0,0,0,.55)}' +
    /* Nut kieu Alia: serif, title case, bo goc — KHONG phai chu hoa gian chu nhu ban cu */
    '#tk-pop .lbp-btn{display:block;width:100%;max-width:18rem;padding:.9rem 1rem;border:0;border-radius:6px;background:' + INKBTN + ';color:#fff!important;font-family:var(--font-body--family,system-ui,sans-serif);font-size:16px;font-weight:700;letter-spacing:0;text-transform:none;line-height:1.2;cursor:pointer;text-decoration:none;text-align:center}' +
    '#tk-pop .lbp-btn:hover{filter:brightness(1.06)}' +
    '#tk-pop .lbp-skip{background:none;border:0;color:#fff;font-size:11px;letter-spacing:.18em;text-transform:uppercase;text-decoration:underline;cursor:pointer;margin-top:.35rem;text-shadow:0 1px 6px rgba(0,0,0,.85)}' +
    /* O nhap TRANG nhu Alia (ban cu la nen toi trong suot). !important vi theme co rule
       `input,textarea,select{background/border/color ... !important}` — di san dot lat nen trang. */
    '#tk-pop input{width:100%;max-width:18rem;padding:.85rem .9rem;border:1px solid #fff!important;border-radius:6px;background:#fff!important;color:#1a1610!important;font-size:15px}' +
    '#tk-pop input::placeholder{color:#8d8778}' +
    '#tk-pop .lbp-err{color:#ffb3ab;font-size:12px;min-height:15px;margin:0}' +
    '#tk-pop .lbp-code{font-family:monospace;font-size:26px;letter-spacing:.12em;background:rgba(255,255,255,.12);border:1px dashed ' + GOLD + ';border-radius:8px;padding:.55rem 1.1rem;user-select:all}' +
    '#tk-pop .lbp-fine{font-size:10.5px;opacity:.85;max-width:20rem;line-height:1.5;text-shadow:0 1px 6px rgba(0,0,0,.85)}' +
    '#tk-pop .lbp-fine a{color:#fff}' +
    /* Khoi dieu khoan SMS nam TREN o so dien thoai (Alia lam vay), chu hoa rat nho tren nen den.
       Day la disclosure TCPA nen bat buoc phai doc duoc ro — khong duoc de chim vao anh nen.
       color phai !important: theme dat rule color rieng cho tung the, ma rule truc tiep luon thang
       gia tri KE THUA tu .lbp-card du specificity thap hon. */
    '#tk-pop .lbp-note{max-width:18rem;background:#000;color:#fff!important;font-size:8.5px;line-height:1.45;' +
    'letter-spacing:.02em;text-transform:uppercase;text-align:center;padding:.5rem .6rem;margin:0}' +
    '#tk-pop .lbp-note a{color:#fff!important;text-decoration:underline}' +
    /* Hang so dien thoai: chon ma vung + o nhap nam chung mot khoi trang bo goc */
    '#tk-pop .lbp-tel{display:flex;align-items:stretch;width:100%;max-width:18rem;background:#fff;border-radius:6px;overflow:hidden}' +
    /* Chi hien LA CO + mui ten, KHONG hien dau so (dung kieu Alia).
       <select> that van giu nguyen de ban phim/mobile chay binh thuong, nhung cho opacity:0 va phu
       kin vung nay -> khong con duong vien nao cua select ve ra man.
       Da BO: box-shadow quanh la co va border-left ngan cach — chinh la 2 "gach doc" user thay. */
    '#tk-pop .lbp-cc{position:relative;flex:0 0 auto;display:flex;align-items:center;gap:5px;padding:0 .6rem;cursor:pointer}' +
    /* DANH SACH xo xuong do trinh duyet ve RIENG, khong an theo opacity:0 cua select —
       nen select tang hinh tren trang ma danh sach van hien, va hien bang mau theme ap vao
       (user thay chu vang kho doc chinh la cho nay). Ep chu den nen trang.
       Phai !important vi theme co rule `input,textarea,select{color/background ... !important}`. */
    '#tk-pop .lbp-cc select{position:absolute;inset:0;width:100%;height:100%;margin:0;padding:0;opacity:0;cursor:pointer;border:0!important;color:#1a1610!important;background:#fff!important}' +
    '#tk-pop .lbp-cc option{color:#1a1610;background:#fff}' +
    '#tk-pop .lbp-flag{display:block;width:22px;height:16px;object-fit:cover;border-radius:2px}' +
    '#tk-pop .lbp-caret{width:0;height:0;border-left:4px solid transparent;border-right:4px solid transparent;border-top:5px solid #6b6357}' +
    '#tk-pop .lbp-tel input{flex:1 1 auto;max-width:none;min-width:0;border:0!important;border-radius:0}' +
    /* 4 o ma OTP — Postscript gui ma 4 CHU SO (da xem tren .com 14/09), khong phai 6 */
    '#tk-pop .lbp-otp{display:flex;gap:.55rem;justify-content:center}' +
    '#tk-pop .lbp-otp input{width:46px!important;max-width:46px;height:52px;padding:0!important;text-align:center;font-size:22px;border-radius:6px}' +
    '#tk-pop .lbp-resend{font-size:12px;margin:.1rem 0}' +
    '#tk-pop .lbp-resend button{background:none;border:0;color:#fff;font-size:12px;text-decoration:underline;cursor:pointer;padding:0}' +
    '#tk-pop .lbp-step{display:flex;flex-direction:column;align-items:center;gap:.65rem;width:100%;animation:tkpUp .5s ease both}' +
    '@keyframes tkpUp{from{opacity:0;transform:translateY(14px)}to{opacity:1;transform:none}}' +
    '@media (max-width:749px){' +
    /* Mobile PHU KIN MAN. Truoc day la kieu "bottom sheet" dan day (the co nen rieng + bo goc,
       nen chi chiem nua duoi, nua tren van thay trang web) — thiet ke cu tu 11/09, sot lai tu
       truoc dot lam giong Alia. Anh Alia o kho iPhone la phu kin ca man.
       Cach sua: anh nen mobile chuyen LEN .lbp-bg (phu toan man), the bo nen rieng + bo goc,
       va bo align-items:flex-end de the ve giua nhu desktop. */
    '#tk-pop .lbp-bg{background:linear-gradient(rgba(0,0,0,.35),rgba(0,0,0,.35)),url(' + JSON.stringify(assetUrl('tk-popup-bg-m.webp')) + ') 50%/cover no-repeat #000}' +
    '#tk-pop .lbp-card{max-width:none;border-radius:0;padding:1.6rem 1.1rem 2rem;background:none}' +
    /* X giu kieu fixed goc man nhu desktop (Alia cung de o goc); neu de absolute theo the thi
       the ve giua se keo X lung lo giua man. Chi thu nho kich thuoc. */
    '#tk-pop .lbp-x{width:32px;height:32px;line-height:32px;font-size:15px}' +
    '}';

  function ensureCss() {
    if (document.getElementById('tk-pop-css')) return;
    var t = document.createElement('style'); t.id = 'tk-pop-css'; t.textContent = css;
    document.head.appendChild(t);
  }

  /* ---------- DOM ---------- */
  var root = null, quizAnswer = null, pendingPhone = '';
  var buocHienTai = '';

  /* ---------------------------- PHEU POPUP ----------------------------
     Truoc day popup chi ban 'lead' luc submit -> khong biet popup hien bao nhieu lan,
     khach chet o buoc nao, kich hoat bang gi. Khong co so nay thi khong A/B duoc
     delay/offer, ma thay WL71 noi day la cho an tien nhat.
     Di duong /px/a (hanh vi) nen KHONG BAO GIO cham Meta; cung client_id nen tu noi
     voi heatmap va voi 'lead' trong lb.v_timeline. */
  function bao(ten, chiTiet, lan, t0) {
    t0 = t0 || Date.now();
    try {
      var c = (window.__tkpx || window.__lbpx) || {};
      /* Cat duoi '/e' bang SO SANH CHUOI va doc cookie bang split — KHONG dung regex.
         Da bon lan dinh bay escape qua nhieu lop (heredoc long template literal an mot cap):
         /D/g -> /D/g, roi /e$ -> //e$ (mo chu thich, vo cau lenh), roi 's' mat mot cap.
         Bo han backslash thi khong con gi de mat. */
      var url = String(c.collect || 'https://api.totkind.com/px/e');
      url = (url.slice(-2) === '/e') ? url.slice(0, -2) + '/a' : url;
      var cid = '';
      var mieng = document.cookie.split(';');
      for (var i = 0; i < mieng.length; i++) {
        var kv = mieng[i].split('=');
        if (kv[0].trim() === '_shopify_y') { cid = decodeURIComponent(kv.slice(1).join('=')); break; }
      }
      cid = maKhach(cid);
      /* 27/09: chua co ma (popup mo ngay luc tai trang, pixel chua kip ghi _lbx_sy) -> CHO toi 5s roi gui,
         giu nguyen gio goc t0. Truoc day `return` luon = mat popup_show. */
      if (!cid) { if ((lan || 0) < 10) setTimeout(function () { bao(ten, chiTiet, (lan || 0) + 1, t0); }, 500); return; }
      var P = window.Shopify && window.Shopify.customerPrivacy;
      /* Doc khong ra API dong y -> COI NHU CO phan tich, dung chinh sach da chot cua du an
         ("doc khong ra thi cho chay phan phan tich, nhung KHONG ban Meta") va dung voi hai
         nguon ghi kia (theme + web pixel deu mac dinh true). Truoc day cho nay mac dinh FALSE
         nen popup tu coi khach la da tu choi roi im lang bo su kien — chi vi API privacy chua
         kip nap. Hau qua do duoc: phieu popup dem THIEU so voi thuc te, va hai script ghi cung
         mot bang lb.activity lai mac dinh nguoc nhau. Rieng `cm` van giu mac dinh FALSE. */
      var ca = P ? !!P.analyticsProcessingAllowed() : true;
      if (!ca) return;                       /* chua dong y phan tich thi khong ghi gi */
      /* Gan su kien popup vao dung TRANG va PHIEN dang dien ra. Truoc do tao de rong nen
         moi dong popup_* trong kho co page_id/session_id trong — khong noi duoc phe u popup
         voi hanh vi trong trang, mat dung kha nang ma muc 3 vua dung ra.
         Hai ma do script theme (lb-px.js) so huu; o day chi DOC. Khong dung regex. */
      var maT = '', maP = '';
      try { var oT = JSON.parse(localStorage.getItem('_lbx_pid') || 'null'); if (oT && oT.id) maT = oT.id; } catch (e) {}
      try { var oP = JSON.parse(localStorage.getItem('_lbx_sess') || 'null'); if (oP && oP.id) maP = oP.id; } catch (e) {}
      var body = {
        cid: cid, sid: maP, pid: maT,
        url: location.href.slice(0, 1000), path: location.pathname.slice(0, 300),
        vw: window.innerWidth, vh: window.innerHeight,
        country: (window.Shopify && window.Shopify.country) || '',
        ca: ca, regulation: '',
        acts: [{ t: t0, q: 1, n: ten, rg: 'popup', tx: String(chiTiet || '').slice(0, 60) }]
      };
      var j = JSON.stringify(body);
      if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([j], { type: 'text/plain' }));
      else { var r = new XMLHttpRequest(); r.open('POST', url); r.setRequestHeader('Content-Type', 'text/plain'); r.send(j); }
    } catch (e) { /* do luong khong duoc lam vo popup */ }
  }
  function el(tag, cls, html) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (html !== undefined) e.innerHTML = html;
    return e;
  }
  function headerNodes(step) {
    var frag = document.createDocumentFragment();
    var lg = el('img', 'lbp-logo'); lg.src = assetUrl('tk-popup-logo.webp'); lg.alt = 'Totkind';
    frag.appendChild(lg);
    /* Chi 2 buoc dau moi doi "You've Got / Mystery Discount"; phone, otp, reward co tieu de rieng (kieu Alia) */
    if (step === 'quiz' || step === 'email') {
      frag.appendChild(el('h2', 'lbp-h2', 'A little gift'));
      frag.appendChild(el('p', 'lbp-h1', 'for your growing family'));
    }
    return frag;
  }
  function render(step) {
    buocHienTai = step;
    bao('popup_step', step);
    var card = root.querySelector('.lbp-card');
    card.innerHTML = '';
    /* X con cua card: desktop fixed goc man hinh, mobile absolute goc card */
    var x = el('button', 'lbp-x', '✕'); x.setAttribute('aria-label', 'Close'); x.onclick = dismiss;
    card.appendChild(x);
    var box = el('div', 'lbp-step');
    box.appendChild(headerNodes(step));

    if (step === 'quiz') {
      box.appendChild(el('p', 'lbp-sub', 'Tell us one thing to unlock it: who is this keepsake for?'));
      /* 08/10: dap an theo nguoi mua that cua ngach (data review: ong ba mua nhieu nhat, cap doi mua de bao tin) */
      ['Us, we are expecting', 'Our new baby', 'A gift for family or friends'].forEach(function (a) {
        var b = el('button', 'lbp-btn', a);
        b.onclick = function () { quizAnswer = a; bao('popup_answer', a); render('email'); };
        box.appendChild(b);
      });
    }

    if (step === 'email') {
      var nameI = el('input'); nameI.placeholder = 'Your name'; nameI.autocomplete = 'given-name';
      var mailI = el('input'); mailI.type = 'email'; mailI.placeholder = 'Your email address'; mailI.autocomplete = 'email';
      var err = el('p', 'lbp-err', '');
      var go = el('button', 'lbp-btn', 'Continue');
      go.onclick = function () {
        var em = (mailI.value || '').trim();
        if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(em)) { err.textContent = 'Please enter a valid email address.'; return; }
        go.disabled = true; go.textContent = 'One moment…';
        emitIdentity(em, (nameI.value || '').trim());   /* vao kho truoc, khong phu thuoc Klaviyo */
        /* Sang buoc SO DIEN THOAI chu khong nhay thang toi reward.
           Postscript bat buoc o SDT phai TACH RIENG khoi o email va hien rieng, khong gop chung. */
        subscribe(em, (nameI.value || '').trim()).then(function () {
          setSt({ signedUp: 1, signedUpAt: Date.now() });
          render('phone');   /* 08/10 user: GIU buoc SDT, chi bo OTP */
        }).catch(function (e) {
          /* van cho khach di tiep — loi mang khong duoc chan luong.
             NHUNG phai bao ra ngoai: truoc day loi Klaviyo bi nuot HOAN TOAN (khong log, khong
             gui di dau), co `syncFailed` chi duoc GHI chu khong cho nao DOC lai, ma `signedUp`
             thi khoa popup vinh vien -> khach khong vao duoc list va khong bao gio co lan thu hai,
             con minh thi khong he biet. Ban sang /px/a de no hien trong kho ma dem duoc.
             Email KHONG mat: emitIdentity() o tren da ban vao lb.events truoc khi goi Klaviyo. */
          try { bao('popup_sync_fail', String((e && e.message) || e || 'klaviyo')); } catch (e2) {}
          setSt({ signedUp: 1, signedUpAt: Date.now(), syncFailed: 1 });
          render('phone');
        });
      };
      mailI.addEventListener('keydown', function (e) { if (e.key === 'Enter') go.click(); });
      /* Alia khong co dong chu nho nao o buoc email — user chot lam y het ca phan noi dung. */
      box.appendChild(nameI); box.appendChild(mailI); box.appendChild(err); box.appendChild(go);
    }

    /* ---------------------------- BUOC SO DIEN THOAI ----------------------------
       Dung dung kieu Alia (xem 5 man that tren .com 14/09): tieu de rieng, khoi dieu khoan SMS
       nam TREN o nhap, o nhap co chon ma vung, nut "Continue".
       Dong y bang HANH DONG BAM NUT (clickwrap) chu khong phai o tick — do la mau Alia dang dung,
       ma Alia la doi tac tich hop chinh thuc cua Postscript. */
    if (step === 'phone') {
      box.appendChild(el('h2', 'lbp-h2', 'Finish Signing Up'));
      box.appendChild(el('p', 'lbp-sub', 'Add your number for order updates and members-only offers by text'));
      box.appendChild(el('p', 'lbp-note',
        '*By providing your number and clicking the button, you agree to receive recurring auto-dialed marketing SMS ' +
        '(including cart reminders; AI content; artificial or prerecorded voices) from Totkind. ' +
        /* /policies/terms-of-service tra 404 tren CA HAI store (da do) — trang that nam o
           /pages/terms-of-service. Alia tren .com dang link vao dung trang 404 do; khong chep lai loi. */
        'Consent is not required to purchase. Msg frequency varies. Msg & data rates may apply. Reply HELP for help, STOP to opt-out. ' +
        'View <a href="/policies/privacy-policy" target="_blank" rel="noopener">Privacy Policy</a>.'));

      /* Chi liet ke nuoc Postscript gui duoc. VN CO TINH khong co trong danh sach — Postscript
         khong gui SMS ve VN, de vao chi lam khach nhap roi ket o buoc OTP. */
      /* MA CHU 2 ky tu, KHONG dung emoji co: Windows khong co font co nen emoji regional-indicator
         hien ra o vuong — da thay tan mat trong anh chup ("□□ +1"). Loi nay dinh moi khach Windows,
         khong phai rieng may tao. Alia hien duoc co vi ho dung anh SVG chu khong phai emoji. */
      var NUOC = [['US', '+1'], ['CA', '+1'], ['GB', '+44'], ['IE', '+353'], ['AU', '+61'],
                  ['DE', '+49'], ['FR', '+33'], ['ES', '+34'], ['IT', '+39'], ['PT', '+351'],
                  ['AT', '+43'], ['BE', '+32'], ['SE', '+46'], ['CH', '+41'], ['MT', '+356']];
      var telRow = el('div', 'lbp-tel');
      var oCo = el('div', 'lbp-cc');
      var laCo = el('img', 'lbp-flag'); laCo.alt = '';
      var cc = document.createElement('select');
      cc.setAttribute('aria-label', 'Country code');
      NUOC.forEach(function (n) {
        var o = document.createElement('option');
        o.value = n[1]; o.textContent = n[0] + ' ' + n[1];
        cc.appendChild(o);
      });
      /* tra co theo selectedIndex, KHONG theo value: US va CA deu la '+1' nen tra theo
         ma vung se luon ra nham co */
      function veCo() { laCo.src = CO[NUOC[cc.selectedIndex][0]] || ''; }
      veCo();
      oCo.appendChild(laCo); oCo.appendChild(el('span', 'lbp-caret')); oCo.appendChild(cc);
      var telI = el('input'); telI.type = 'tel'; telI.placeholder = 'Your phone number'; telI.autocomplete = 'tel';
      /* US/CA (+1): go toi dau dinh dang toi do -> (307) 223-2929. Nuoc khac de nguyen so vi
         moi nuoc mot kieu, dinh dang bua con kho doc hon de nguyen.
         Khong anh huong luong gui di: cho submit da strip /\D/g roi moi ghep ma vung. */
      function dinhDang(d) {
        if (cc.value !== '+1') return d;
        d = d.slice(0, 10);
        if (!d) return '';
        if (d.length <= 3) return '(' + d;
        if (d.length <= 6) return '(' + d.slice(0, 3) + ') ' + d.slice(3);
        return '(' + d.slice(0, 3) + ') ' + d.slice(3, 6) + '-' + d.slice(6);
      }
      /* Dung [^0-9] chu KHONG dung \D: dong nay tung bi ghi hong thanh /D/g (mat gach cheo nguoc
         vi doan thay the nam trong heredoc LONG template literal, hai lop an mat mot cap).
         Hau qua luc do: khong strip duoc ngoac -> moi lan go lai boc them mot lop -> "(((3) 07".
         Lop ky tu [^0-9] khong co gach cheo nguoc nen khong the tai dien kieu loi nay. */
      function dinhDangLai() { telI.value = dinhDang((telI.value || '').replace(/[^0-9]/g, '')); }
      telI.addEventListener('input', dinhDangLai);
      cc.addEventListener('change', function () { veCo(); dinhDangLai(); });
      telRow.appendChild(oCo); telRow.appendChild(telI);
      var perr = el('p', 'lbp-err', '');
      var pgo = el('button', 'lbp-btn', 'Continue');

      pgo.onclick = function () {
        /* bo moi ky tu khong phai so, bo so 0 dau (dang noi dia) roi ghep ma vung */
        var so = (telI.value || '').replace(/\D/g, '').replace(/^0+/, '');
        /* Nguong theo MA VUNG, khong dung chung mot con so cho ca 15 nuoc. So US/CA bat buoc
           du 10 chu so; de nguong 7 thi khach go thieu ma vung ('223 2929') van lot qua, roi
           '+12232929' bi day vao kho lam KHOA DANH TINH thu ba — sai vinh vien va khong sua duoc,
           trong khi Postscript thi tu choi nen khach cung khong nhan duoc ma. */
        var toiThieu = (cc.value === '+1') ? 10 : 7;
        if (so.length < toiThieu) { perr.textContent = 'Please enter a valid phone number.'; return; }
        var sdt = cc.value + so;
        pgo.disabled = true; pgo.textContent = 'One moment…';

        /* 08/10 Totkind: KHONG OTP (user chot). Luu kho + gui so vao Klaviyo (list Text Messaging), loi cung di tiep */
        emitPhone(sdt);
        subscribeSms(sdt).catch(function (e) { try { bao('popup_sms_fail', String((e && e.message) || e)); } catch (x) {} })
          .then(function () { setSt({ phone: 1 }); render('reward'); });
      };
      /* Alia khong co nut bo qua o buoc nay — bo theo. Hau qua: khach khong cho so thi khong
         den duoc man reward, chi con cach dong popup. */
      telI.addEventListener('keydown', function (e) { if (e.key === 'Enter') pgo.click(); });
      box.appendChild(telRow); box.appendChild(perr);
      box.appendChild(pgo);
    }

    /* Buoc nhap ma OTP — chi hien khi Postscript tra ve trang thai chua xac thuc.
       Ma la 4 CHU SO: da xem tan mat tin nhan that tren .com 14/09, khong phai 6 nhu tao doan luc dau. */
    if (step === 'otp') {
      box.appendChild(el('h2', 'lbp-h2', 'We sent you a code'));
      box.appendChild(el('p', 'lbp-sub', 'Validate your phone number by entering the code we sent you'));
      var oerr = el('p', 'lbp-err', '');
      var ogo = el('button', 'lbp-btn', 'Activate My Discount');

      var rs = el('p', 'lbp-resend', "Didn't get a code? ");
      var rsb = el('button', null, 'Resend code');
      rsb.onclick = function () {
        var a = psAcq();
        /* resendOtp(n) -> Bx(shopId, n, ...) voi n = phone_number: tham so la CHUOI so, khong phai
           object (khac verify). Goi rong thi phone_number = undefined nen khong gui lai duoc gi.

           CHI duoc bao thanh cong khi THAT SU gui duoc. Truoc day dong 'Code sent again.' nam
           NGOAI try va khong phu thuoc dieu kien nao: SDK bien mat (bi chan quang cao / go app)
           -> a = null -> khong goi gi ma khach van doc "da gui lai" roi ngoi cho mot tin nhan
           khong bao gio den. Loi bi try nuot, hoac Promise bi tu choi, deu cho ket qua y het. */
        if (!a || typeof a.resendOtp !== 'function') {
          oerr.textContent = 'We could not resend the code.';
          return;
        }
        rsb.disabled = true;
        Promise.resolve().then(function () { return a.resendOtp(pendingPhone); })
          .then(function () { oerr.textContent = 'Code sent again.'; })
          .catch(function () { oerr.textContent = 'We could not resend the code.'; })
          .then(function () { rsb.disabled = false; });
      };
      rs.appendChild(rsb);

      var oWrap = el('div', 'lbp-otp');
      var oIns = [];
      for (var i = 0; i < 4; i++) {
        var ci = el('input');
        ci.type = 'text'; ci.inputMode = 'numeric'; ci.maxLength = 1;
        ci.setAttribute('aria-label', 'Digit ' + (i + 1));
        oWrap.appendChild(ci); oIns.push(ci);
      }
      /* go xong tu nhay o ke tiep, backspace lui lai, dan ca ma thi rai deu ra cac o */
      oIns.forEach(function (c, idx) {
        c.addEventListener('input', function () {
          c.value = (c.value || '').replace(/\D/g, '').slice(0, 1);
          if (c.value && idx < 3) oIns[idx + 1].focus();
        });
        c.addEventListener('keydown', function (e) {
          if (e.key === 'Backspace' && !c.value && idx > 0) oIns[idx - 1].focus();
          if (e.key === 'Enter') ogo.click();
        });
        c.addEventListener('paste', function (e) {
          var t = (((e.clipboardData || window.clipboardData) || {}).getData('text') || '').replace(/\D/g, '');
          if (!t) return;
          e.preventDefault();
          for (var k = 0; k + idx < 4 && k < t.length; k++) oIns[idx + k].value = t.charAt(k);
          oIns[Math.min(3, idx + t.length - 1)].focus();
        });
      });

      ogo.onclick = function () {
        var ma = oIns.map(function (c) { return c.value || ''; }).join('');
        if (ma.length < 4) { oerr.textContent = 'Please enter the 4-digit code.'; return; }
        var acq2 = psAcq();
        if (!acq2 || typeof acq2.verify !== 'function') {
          /* KHONG duoc lang le nhay sang reward: nhu vay la bao "xong" trong khi chua he xac thuc
             duoc gi — cung loai loi da sua o nhanh optIn. Va no con lam ta khong phan biet duoc
             "verify thanh cong that" voi "nhay qua" khi nhin man hinh. */
          oerr.textContent = 'We could not check your code right now.';
          ogo.disabled = false; ogo.textContent = 'Continue without texts';
          ogo.onclick = function () { setSt({ phone: 1 }); render('reward'); };
          return;
        }
        ogo.disabled = true; ogo.textContent = 'Checking…';
        /* Chu ky THAT doc tu sdk.bundle.js: verify(n, i) voi n.code va n.phoneNumber
           -> tham so 1 la OBJECT, khong phai chuoi ma. Goi verify(ma) thi ca hai truong deu
           undefined nen server luon tra that bai — do la ly do ma DUNG van bao "code did not work". */
        /* Boc trong .then() chu KHONG goi thang trong Promise.resolve(): neu SDK nem loi DONG BO
           (vd init chua thanh cong nen shopId undefined) thi ngoai le thoat khoi ca onclick,
           khong nhanh .catch nao chay, ma nut thi da bi disable + doi chu tu truoc -> ket cung
           o 'Checking…' khong mot dong bao loi. Boc lai thi throw dong bo thanh rejection. */
        Promise.resolve().then(function () { return acq2.verify({ code: ma, phoneNumber: pendingPhone }); })
          .then(function () { setSt({ phone: 1 }); render('reward'); })
          .catch(function () {
            ogo.disabled = false; ogo.textContent = 'Activate My Discount';
            oerr.textContent = 'That code did not work.';
          });
      };
      box.appendChild(rs); box.appendChild(oWrap); box.appendChild(oerr); box.appendChild(ogo);
      setTimeout(function () { try { oIns[0].focus(); } catch (e) {} }, 60);
    }

    if (step === 'reward') {
      /* Y HET Alia ke ca noi dung (user chot 14/09): KHONG hien ma tren man, khong dong chu nho.
         Nut "Shop now" van tu ap ma qua /discount/ nen ai bam nut la co giam gia ngay.
         RUI RO da bao user: ai KHONG bam nut thi phai cho ma qua email/SMS, ma list Klaviyo cua .co
         hien chua gan flow nao -> nhung nguoi do khong nhan duoc ma. */
      /* 08/10: HIEN ma ngay (list Klaviyo Totkind chua co flow -> "check inbox" = khach khong nhan duoc ma) */
      box.appendChild(el('h2', 'lbp-h1', "You're in!"));
      box.appendChild(el('p', 'lbp-sub', 'Here is 5% off your order. It is already applied when you tap the button.'));
      var ma = el('div', 'lbp-code', CODE); box.appendChild(ma);
      var shop = el('a', 'lbp-btn', 'Apply & keep shopping');
      var ve = location.pathname + location.search.replace(/[?&]tkpopup=[^&]*/, '').replace(/^&/, '?');
      shop.href = '/discount/' + CODE + '?redirect=' + encodeURIComponent(/^\/(cart|checkout)/.test(ve) ? '/collections/all' : ve);
      box.appendChild(shop);
    }
    /* 08/10 user: dong 'No thanks' duoi cung de dong popup (quiz, email). O buoc SDT khach DA signup:
       dong luc nay = mat ma WELCOME5 (chi hien o reward) -> 'No thanks' bo qua SDT, sang reward. */
    if (step === 'quiz' || step === 'email' || step === 'phone') {
      var no = el('button', 'lbp-skip', 'No thanks'); no.type = 'button';
      no.onclick = step === 'phone' ? function () { bao('popup_skip', 'phone'); render('reward'); } : dismiss;
      box.appendChild(no);
    }
    card.appendChild(box);
  }

  function mount() {
    if (root) return;
    ensureCss();
    root = el('div'); root.id = 'tk-pop'; root.hidden = true;
    var bg = el('div', 'lbp-bg');
    /* KHONG gan click-de-dong len nen (user chot 14/09). Da do truoc khi go: chi dung duong nay
       lam tat popup — bam vao the, o nhap so, vung chon nuoc, hay chon nuoc trong danh sach deu
       KHONG tat, tren ca desktop lan mobile va ca hai store. Nen chi can go dung dong nay.
       Giu lai chinh phan tu .lbp-bg vi no con nhiem vu ve anh nen toi.
       08/10: them lai "No thanks" (quiz/email/phone) ben canh nut X. */
    root.appendChild(bg);
    root.appendChild(el('div', 'lbp-card'));
    document.body.appendChild(root);
  }
  var opened = false;
  function open(lyDo) {
    if (opened || st().signedUp && debug !== '1') return;
    opened = true;
    mount();
    bao('popup_show', lyDo || 'khong ro');
    render('quiz');
    root.hidden = false;
    document.documentElement.style.overflow = 'hidden';
    setSt({ lastShownAt: Date.now() });
  }
  function closeOnly() {
    if (root) root.hidden = true;
    document.documentElement.style.overflow = '';
    opened = false;
  }
  function dismiss() {
    /* wasReward cu do '.lbp-code' -> khoi hien ma da bo khi lam giao dien y het Alia,
       nen no LUON false. Dung moc that: da toi buoc reward hay chua. */
    var wasReward = buocHienTai === 'reward';
    bao('popup_close', buocHienTai || 'khong ro');
    closeOnly();
    if (!wasReward && !st().signedUp) setSt({ dismissedAt: Date.now() });   /* 08/10: bo floating pill */
  }

  /* ---------- Klaviyo subscribe (client endpoint, khong can secret) ---------- */
  /* ---------- khoa thu HAI cua kho du lieu: email ----------
     Client ID (_shopify_y) chet khi khach doi may hoac xoa cookie. Thay WL71:
     lay email o thiet bi 1 roi noi vao client ID moi o thiet bi 2 -> van la mot nguoi,
     van quy dung ve campaign. Popup chinh la cho lay email do.
     Ban ten su kien 'lead' — CO Y khong nam trong danh sach gui Meta, chi vao kho. */
  /* Doc ma phien do script theme (lb-px.js) so huu.
     Khong co cai nay thi dong `lead` trong lb.events rong session_id — do that: 124/124 dong
     deu rong — nen email/phone khong noi duoc vao phien ma no phat sinh, mat nua gia tri cua
     khoa danh tinh. Khong dung regex (bay escape da dinh 4 lan trong phien nay).
     CO Y khong gop chung voi doan doc trong bao(): bao() vua kiem xong va dang chay dung,
     khong dung vao thu dang chay tot khi di sua thu khac. */
  function docPhien() {
    try { var o = JSON.parse(localStorage.getItem('_lbx_sess') || 'null'); return (o && o.id) || ''; }
    catch (e) { return ''; }
  }
  function emitIdentity(email, name) {
    try {
      var cfg = (window.__tkpx || window.__lbpx) || {};
      var url = cfg.collect || 'https://api.totkind.com/px/e';
      var ck = function (n) { var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)'); return m ? decodeURIComponent(m[2]) : ''; };
      var cid = maKhach(ck('_shopify_y'));
      if (!cid) return;
      var P = window.Shopify && window.Shopify.customerPrivacy;
      /* Doc khong ra API dong y -> COI NHU CO phan tich, dung chinh sach da chot cua du an
         ("doc khong ra thi cho chay phan phan tich, nhung KHONG ban Meta") va dung voi hai
         nguon ghi kia (theme + web pixel deu mac dinh true). Truoc day cho nay mac dinh FALSE
         nen popup tu coi khach la da tu choi roi im lang bo su kien — chi vi API privacy chua
         kip nap. Hau qua do duoc: phieu popup dem THIEU so voi thuc te, va hai script ghi cung
         mot bang lb.activity lai mac dinh nguoc nhau. Rieng `cm` van giu mac dinh FALSE. */
      var ca = P ? !!P.analyticsProcessingAllowed() : true;
      var cm = P ? !!P.marketingAllowed() : false;
      if (!ca) return;                       /* EU/UK chua dong y thi khong luu gi */
      var parts = String(name || '').trim().split(/\s+/);
      var body = {
        name: 'lead', src: 'web', ts: Date.now(),
        shop: cfg.shop || location.hostname,
        cid: cid, sy: cid, sid: docPhien(),
        email: email,
        first_name: parts[0] || '',
        last_name: parts.length > 1 ? parts[parts.length - 1] : '',
        country: (window.Shopify && window.Shopify.country) || '',
        url: location.href.slice(0, 300),
        path: location.pathname.slice(0, 200),
        fbc: ck('_fbc'), fbp: ck('_fbp'),
        ca: ca, cm: cm
      };
      var s = JSON.stringify(body);
      if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([s], { type: 'text/plain' }));
      else { var r = new XMLHttpRequest(); r.open('POST', url); r.setRequestHeader('Content-Type', 'text/plain'); r.send(s); }
    } catch (e) { /* do luong khong duoc lam hong popup */ }
  }

  /* Day SO DIEN THOAI vao kho lam KHOA DANH TINH THU BA (cung client_id va email).
     Doc lap hoan toan voi Postscript: kho nhan duoc ngay ca khi chua cai app SMS nao. */
  function emitPhone(phone) {
    try {
      var cfg2 = (window.__tkpx || window.__lbpx) || {};
      var url = cfg2.collect || 'https://api.totkind.com/px/e';
      var ck2 = function (n) { var m = document.cookie.match('(^|;)\\s*' + n + '\\s*=\\s*([^;]+)'); return m ? decodeURIComponent(m[2]) : ''; };
      var cid = maKhach(ck2('_shopify_y'));
      if (!cid) return;
      var P = window.Shopify && window.Shopify.customerPrivacy;
      /* Doc khong ra API dong y -> COI NHU CO phan tich, dung chinh sach da chot cua du an
         ("doc khong ra thi cho chay phan phan tich, nhung KHONG ban Meta") va dung voi hai
         nguon ghi kia (theme + web pixel deu mac dinh true). Truoc day cho nay mac dinh FALSE
         nen popup tu coi khach la da tu choi roi im lang bo su kien — chi vi API privacy chua
         kip nap. Hau qua do duoc: phieu popup dem THIEU so voi thuc te, va hai script ghi cung
         mot bang lb.activity lai mac dinh nguoc nhau. Rieng `cm` van giu mac dinh FALSE. */
      var ca = P ? !!P.analyticsProcessingAllowed() : true;
      if (!ca) return;                       /* EU/UK chua dong y thi khong luu */
      var body = {
        name: 'lead', src: 'web', ts: Date.now(),
        shop: cfg2.shop || location.hostname,
        cid: cid, sy: cid, sid: docPhien(),
        phone: phone,
        country: (window.Shopify && window.Shopify.country) || '',
        url: location.href.slice(0, 300), path: location.pathname.slice(0, 200),
        fbc: ck2('_fbc'), fbp: ck2('_fbp'),
        ca: ca, cm: P ? !!P.marketingAllowed() : false
      };
      var s = JSON.stringify(body);
      if (navigator.sendBeacon) navigator.sendBeacon(url, new Blob([s], { type: 'text/plain' }));
      else { var r = new XMLHttpRequest(); r.open('POST', url); r.setRequestHeader('Content-Type', 'text/plain'); r.send(s); }
    } catch (e) {}
  }

  /* SDK cua Postscript neu co tren trang. .co CHUA cai Postscript nen hien tai luon rong —
     viet kieu tu do de cai app xong la tu chay, khong phai sua code lan nua.
     Alia goi dung bo ham nay: acquisition.init -> optIn -> verify/resendOtp. */
  function psAcq() {
    try {
      var p = window.postscript;
      return (p && p.acquisition && typeof p.acquisition.optIn === 'function') ? p.acquisition : null;
    } catch (e) { return null; }
  }

  function subscribe(email, name) {
    var payload = {
      data: {
        type: 'subscription',
        attributes: {
          custom_source: 'totkind.com popup',
          profile: {
            data: {
              type: 'profile',
              attributes: {
                email: email,
                first_name: name || undefined,
                properties: {
                  'Popup Quiz - Shopping For': quizAnswer || 'unanswered',
                  'Store': 'Totkind',
                  'Signup Source': 'totkind.com popup'
                }
              }
            }
          }
        },
        relationships: { list: { data: { type: 'list', id: KLAVIYO_LIST } } }
      }
    };
    /* XHR thay vi fetch: ne cac wrapper fetch cua web pixel tren theme */
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('POST', 'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY);
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('revision', '2025-04-15');
      x.onload = function () { (x.status >= 200 && x.status < 300) ? resolve() : reject(new Error('klaviyo ' + x.status)); };
      x.onerror = function () { reject(new Error('klaviyo network')); };
      x.send(JSON.stringify(payload));
    });
  }

  /* 08/10: so dien thoai -> Klaviyo list Text Messaging (WvGefw) kem dong y SMS marketing (clickwrap o tren).
     Can bat SMS trong Klaviyo (so gui US) thi tin moi di; chua bat thi Klaviyo van luu so vao ho so. */
  var KLAVIYO_SMS_LIST = 'WvGefw';
  function subscribeSms(phone) {
    var payload = { data: { type: 'subscription', attributes: { custom_source: 'totkind.com popup (phone)',
      profile: { data: { type: 'profile', attributes: { phone_number: phone,
        subscriptions: { sms: { marketing: { consent: 'SUBSCRIBED' } } },
        properties: { 'Signup Source': 'totkind.com popup' } } } } },
      relationships: { list: { data: { type: 'list', id: KLAVIYO_SMS_LIST } } } } };
    return new Promise(function (resolve, reject) {
      var x = new XMLHttpRequest();
      x.open('POST', 'https://a.klaviyo.com/client/subscriptions/?company_id=' + KLAVIYO_COMPANY);
      x.setRequestHeader('Content-Type', 'application/json');
      x.setRequestHeader('revision', '2025-04-15');
      x.onload = function () { (x.status >= 200 && x.status < 300) ? resolve() : reject(new Error('klaviyo sms ' + x.status)); };
      x.onerror = function () { reject(new Error('klaviyo sms network')); };
      x.send(JSON.stringify(payload));
    });
  }

  /* ---------- triggers ---------- */
  function arm() {
    /* preload de luc trigger bat, nen/logo da nam trong cache */
    try {
      [assetUrl('tk-popup-bg.webp'), assetUrl('tk-popup-bg-m.webp'), assetUrl('tk-popup-logo.webp')]
        .forEach(function (u) { var im = new Image(); im.src = u; });
    } catch (e) {}
    if (debug === '1') { open('debug'); return; }
    if (dismissedRecently) return;
    var fired = false;
    function fire(lyDo) { if (fired) return; fired = true; cleanup(); open(lyDo); }
    /* 1. 30s tren trang */
    var tm = setTimeout(function () { fire('30s'); }, 30000);
    /* 2. cuon qua 50% */
    function onScroll() {
      var h = document.documentElement;
      var max = h.scrollHeight - innerHeight;
      if (max > 200 && h.scrollTop / max >= 0.5) fire('scroll');
      /* 4. mobile quick scroll-up */
      var y = h.scrollTop;
      if (isMobile && y < lastY - 220 && y > 300) fire('scrollup');
      lastY = y;
    }
    var lastY = 0, isMobile = matchMedia('(max-width:749px)').matches;
    addEventListener('scroll', onScroll, { passive: true });
    /* 3. exit intent desktop */
    function onOut(e) {
      if (!isMobile && !e.relatedTarget && e.clientY <= 0) fire('exit');
    }
    document.addEventListener('mouseout', onOut);
    function cleanup() {
      clearTimeout(tm);
      removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onOut);
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', arm, { once: true });
  else arm();
})();
